import(/* webpackMode: "eager", webpackExports: ["ForgotPassword"] */ "/vercel/path0/apps/keesy/src/app/[locale]/(login-pages)/forgot-password/ForgotPassword.tsx");
